import React, { useState, useEffect, useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import './GeneralQRCode.css';

const GeneralQRCode = () => {
  const [qrUrl, setQrUrl] = useState('');
  const [customUrl, setCustomUrl] = useState('');
  const [useCustom, setUseCustom] = useState(false);
  const qrRef = useRef(null);

  useEffect(() => {
    // Generer l'URL du QR code basee sur l'URL actuelle du navigateur
    // Si l'admin accede via http://192.168.1.50:3000, le QR code pointera vers cette meme base
    const currentOrigin = window.location.origin;
    const scanUrl = `${currentOrigin}/scan?scan=EPI-REQUEST`;
    setQrUrl(scanUrl);
  }, []);

  const getEffectiveUrl = () => {
    if (useCustom && customUrl.trim()) {
      const base = customUrl.trim().replace(/\/$/, '');
      return `${base}/scan?scan=EPI-REQUEST`;
    }
    return qrUrl;
  };

  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    const canvas = qrRef.current?.querySelector('canvas');
    if (canvas) {
      const url = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.download = 'qrcode-epi-demande.png';
      link.href = url;
      link.click();
    }
  };

  const effectiveUrl = getEffectiveUrl();

  return (
    <div className="general-qrcode">
      <div className="qr-page-header">
        <h1>QR Code de demande EPI</h1>
        <p>Imprimez et affichez ce QR code pour que vos agents puissent faire leurs demandes</p>
      </div>

      <div className="qr-main-card">
        <div className="qr-display" ref={qrRef}>
          <div className="qr-frame">
            {effectiveUrl && (
              <QRCodeCanvas
                value={effectiveUrl}
                size={280}
                level="H"
                includeMargin={true}
                bgColor="#ffffff"
                fgColor="#1e293b"
              />
            )}
          </div>
          <p className="qr-label">Scannez pour demander un EPI</p>
        </div>

        <div className="qr-actions">
          <button className="btn-action btn-print" onClick={handlePrint}>
            Imprimer
          </button>
          <button className="btn-action btn-download" onClick={handleDownload}>
            Telecharger PNG
          </button>
        </div>

        <div className="qr-url-section">
          <label className="qr-url-label">URL encodee dans le QR code :</label>
          <code className="qr-url-value">{effectiveUrl}</code>
        </div>

        <div className="qr-custom-section">
          <label className="toggle-label">
            <input
              type="checkbox"
              checked={useCustom}
              onChange={(e) => setUseCustom(e.target.checked)}
            />
            <span>Utiliser une URL personnalisee (tunnel Cloudflare, domaine, etc.)</span>
          </label>
          {useCustom && (
            <input
              type="text"
              className="custom-url-input"
              placeholder="Ex: https://mon-tunnel.trycloudflare.com"
              value={customUrl}
              onChange={(e) => setCustomUrl(e.target.value)}
            />
          )}
        </div>
      </div>

      <div className="qr-info-card">
        <h3>Comment ca marche</h3>
        <div className="steps-grid">
          <div className="step">
            <div className="step-num">1</div>
            <div className="step-text">Imprimez et affichez ce QR code dans vos locaux</div>
          </div>
          <div className="step">
            <div className="step-num">2</div>
            <div className="step-text">L'agent scanne avec son telephone</div>
          </div>
          <div className="step">
            <div className="step-num">3</div>
            <div className="step-text">Une demande est creee automatiquement</div>
          </div>
          <div className="step">
            <div className="step-num">4</div>
            <div className="step-text">Vous validez et attribuez l'EPI depuis l'admin</div>
          </div>
        </div>
      </div>

      <div className="qr-4g-card">
        <h3>Acces en 4G / hors reseau local</h3>
        <p>Pour que le QR code fonctionne en 4G, vous devez exposer votre serveur via un tunnel :</p>
        <ol>
          <li>Installez <strong>Cloudflare Tunnel</strong> : <code>npx cloudflared tunnel --url http://localhost:3000</code></li>
          <li>Copiez l'URL generee (ex: <code>https://xxx.trycloudflare.com</code>)</li>
          <li>Cochez "URL personnalisee" ci-dessus et collez l'URL</li>
          <li>Le QR code se met a jour automatiquement</li>
        </ol>
      </div>
    </div>
  );
};

export default GeneralQRCode;
